module.exports = __webpack_public_path__ + "img/rbx-tree.55b37276.svg";